<script>
  import { _ as t } from "svelte-i18n";

  export let errorMessages;
</script>

<div class="wrapper">
  {#if errorMessages && Array.isArray(errorMessages)}
    {#each errorMessages as errorMessage}
      <div class="error-message">
        {#if typeof errorMessage.message === "string"}
          {$t("error")}:
          {$t(`errors.${errorMessage.message}`)}
        {:else}
          {#each errorMessage.message as message}{message}{/each}
        {/if}
      </div>
    {/each}
  {/if}
</div>

<style>
  .wrapper {
    min-height: 24px;
  }
  .error-message {
    margin: 24px 0;
    color: red;
    max-width: 30em;
    line-height: 1.5rem;
  }
</style>
